export default {
    App: {
        'Browse stock equipment': 'Stock equipment durchsuchen',
        'Contact Kalmar': 'Kalmar kontaktieren',
        'Create new': 'Neu erstellen',
        'Dealer community': 'Dealer community',
        'Download failed': 'Download fehlgeschlagen',
        'Failed to get service reports': 'Abrufen der Wartungsberichte fehlgeschlagen',
        'Kalmar Care service request': 'Kalmar Care Service Anfrage',
        'Kalmar Training Academy': 'Kalmar Schulungsakademie',
        'Kalmar Used Equipment': 'Kalmar Gebrauchtgeräte',
        'Loading MyKalmar': 'MyKalmar wird geladen',
        'Login again': 'Erneut anmelden',
        'Maintenance reporting': 'Wartungsberichte',
        'Maintenance schedule': 'Wartungsplan',
        'Manuals': 'Bedienungsanleitungen',
        'My Cases': 'Meine Anfragen',
        'MyKalmar homepage': 'MyKalmar-Homepage',
        'MyParts': 'MyParts',
        'Navigating to MyParts failed': 'Navigation zu MyParts fehlgeschlagen',
        'No service reports found': 'Keine Wartungsberichte gefunden',
        'None': 'Keine',
        'Open Dealer community': 'Händler Community öffnen',
        'Open MyKalmar INSIGHT': 'MyKalmar INSIGHT öffnen',
        'Open MyKalmar STORE': 'MyKalmar STORE öffnen',
        'Open used equipment sales portal': 'Gebrauchtgeräte-Verkaufsportal öffnen',
        'Parts order history': 'Bestellhistorie',
        'Read more and subscribe': 'Weiterlesen und abonnieren',
        'Read more and register': 'Weiterlesen und registrieren',
        'Register Kalmar equipment': 'Kalmar-Geräte registrieren',
        'Request training': 'Schulungsanforderung',
        'Request service': 'Service anfordern',
        'Show all ({{ equipmentLength }}) equipment': 'Ihr vollständiges Equipment ({{ equipmentLength }}) anzeigen',
        'Show all Kalmar contacts': 'Alle Kalmar-Kontakte anzeigen',
        'Show all orders in MyParts': 'Alle MyParts Bestellungen anzeigen',
        'Show all cases': 'Alle Anfragen anzeigen',
        'Show manuals search': 'Handbuchsuche anzeigen',
        'Show on calendar': 'Im Kalender anzeigen',
        'Show requests': 'Anfragen anzeigen',
        'Try again': 'Versuchen Sie es erneut.',
        'You are now logged out from MyKalmar': 'Sie sind nun von MyKalmar abgemeldet',
        'Open TechSight': 'Öffnen Sie TechSight',
        'Solve smarter: your one-stop information source': 'Intelligenter lösen: Ihre zentrale Informationsquelle',
    },
    BackToTop: {
        'Back to top': 'Zurück nach oben',
    },
    Banner: {
        'Boost driving skills and technical expertise with Kalmar Training Academy specialized training courses, designed to keep your team & equipment safe and reliable.': 'Steigern Sie die Fahrfähigkeiten und technische Expertise mit den spezialisierten Schulungskursen der Kalmar Training Academy, die darauf ausgelegt sind, Ihr Team und Ihre Ausrüstung sicher und zuverlässig zu halten.',
        'Check details for your equipment until they last.': 'Überprüfen Sie die Details für Ihre Ausrüstung, solange sie verfügbar sind.',
        'Discover how to get the most out of your equipment.': 'Finden Sie heraus, wie Sie Ihre Fahrzeugflotte optimal nutzen können.',
        'Ensure uptime, optimize your operations, and much more.': 'Halten Sie Ihre Flotte intakt, optimieren Sie Ihre Abläufe und vieles mehr.',
        'Explore Kalmar Services': 'Entdecken Sie die Dienstleistungen von Kalmar',
        'FLASH Sale is now on - Save up to 70%': 'FLASH Sale läuft jetzt – Sparen Sie bis zu 70%',
        'Go to STORE': 'Gehe zum STORE',
        'Learn more': 'Erfahren Sie mehr',
        'Register in STORE now': 'Jetzt im STORE registrieren',
        'Selected Kalmar Genuine Parts now discounted in the MyKalmar STORE Outlet.': 'Ausgewählte Kalmar Originalteile sind jetzt im MyKalmar STORE Outlet reduziert.',
        'Take your team’s performance to the next level!': 'Bringen Sie die Leistung Ihres Teams auf die nächste Stufe!',
    },
    BulletinsTab: {
        'Bulletin': 'Bulletin',
        'Bulletins': 'Bulletins',
        'Product': 'Produkt',
        'Subject': 'Betreff',
        'Date': 'Datum',
        'Open pdf': 'PDF öffnen',
        'Search bulletins': 'Bulletins suchen',
        'Select equipment': 'Gerät auswählen',
        'Category': 'Kategorie',
        'Select category': 'Kategorie auswählen',
        'No bulletins for your fleet.': 'Keine Bulletins für Ihre Flotte.',
        'Bulletins are currently available for select equipment types only. We are actively expanding coverage to include the rest of your fleet in upcoming updates.': 'Derzeit sind Meldungen nur für ausgewählte Gerätetypen verfügbar. Wir arbeiten aktiv daran, den Umfang in kommenden Updates auf den Rest Ihrer Flotte auszuweiten.',
        'Bulletins are visible to Kalmar internal users only.': 'Meldungen sind nur für interne Kalmar-Benutzer sichtbar.',
    },
    Common: {
        'All': 'Alle',
        'Language': 'Sprache',
        'Select language': 'Sprache auswählen',
        'Availability': 'Verfügbarkeit',
        'Call the number': 'Rufen Sie die Nummer an',
        'called': 'Angerufen',
        'Cancel': 'Abbrechen',
        'Close': 'Schließen',
        'Completed': 'Abgeschlossen',
        'Contracts': 'Verträge',
        'Customer number': 'Kundennummer',
        'declined': 'Abgelehnt',
        'Description': 'Beschreibung',
        'Details': 'Details',
        'Maintenance': 'Wartung',
        'Monthly': 'Monatlich',
        'Monthly report': 'Monatlicher Bericht',
        'My Equipment': 'Ihr Equipment',
        'N/A': 'NICHT ZUTREFFEND',
        'Name': 'Name',
        'No data': 'Keine Daten',
        'No data for this time period': 'Keine Daten für diesen Zeitraum',
        'OK': 'OK',
        'ordered': 'Bestellt',
        'Other': 'Sonstige',
        'Other Equipment': 'Sonstige Ausrüstung',
        'Stock equipment': 'Lagerausrüstung',
        'Register Kalmar equipment': 'Kalmar-Geräte registrieren',
        'Request submission failed': 'Anfrage konnte nicht gesendet werden',
        'Response Time': 'Reaktionszeit',
        'scheduled': 'Geplant',
        'See details': 'Siehe Details',
        'Send': 'Senden',
        'Serial number': 'Seriennummer',
        'Show on page': 'Auf der Seite anzeigen',
        'Site': 'Standort',
        'Something went wrong': 'Etwas ist schiefgelaufen.',
        'Status': 'Status',
        'today': 'heute',
        'Type': 'Typ',
        'Unknown': 'Unbekannt',
        'User': 'Benutzer',
        'Yearly': 'Jährlich',
        'Yearly trend': 'Jährlicher Trend',
        'Search': 'Suche',
        'Open': 'Offen',
        'Welcome to MyKalmar': ' Willkommen bei MyKalmar',

    },
    ContactWidget: {
        'Contact us': 'Zögern Sie nicht und kontaktieren Sie uns!',
        'Email': 'E-Mail',
        'Need help?  Or need to know more about our services?': 'Hab Sie Fragen an uns?',
        'Phone': 'Telefon',
        'Send email': 'E-Mail senden',
    },
    CustomerSelector: {
        'No results found with': 'Keine Ergebnisse gefunden mit',
        'Search with name, city, street address or sold-to number': 'Search with name, city, street address or sold-to number',
        'Select customer': 'Kunden auswählen',
    },
    DataRequestForm: {
        'Acceptance of Data Notice': 'Akzeptanz der Datenschutzhinweise',
        'Company name': 'Firmenname',
        'Contact us': 'Kontaktieren Sie uns',
        'Data Act Notice': 'Datengesetz-Hinweis',
        'Data request sent': 'Datenanfrage gesendet',
        'Date of data concerned by the request': 'Datum der von der Anfrage betroffenen Daten',
        'Details': 'Details',
        'Error sending data request:': 'Fehler beim Senden der Datenanfrage:',
        'Fill request form': 'Anfrageformular ausfüllen',
        'Form for data access request': 'Formular für Datenzugriffsanfrage',
        'I have read and agree to the': 'Ich habe die folgenden Hinweise gelesen und stimme ihnen zu:',
        'Name': 'Name',
        'No customer selected': 'Kein Kunde ausgewählt',
        'Open comments': 'Kommentare öffnen',
        'Or alternatively,': 'Oder alternativ,',
        'Position/relationship with the Company': 'Position/Beziehung zum Unternehmen',
        'Products concerned by the request (e.g. serial number)': 'Von der Anfrage betroffene Produkte (z. B. Seriennummer)',
        'Something went wrong': 'Etwas ist schiefgelaufen.',
        'Thank you for your data request': 'Vielen Dank für Ihre Datenanfrage',
        'Past data': 'Vergangene Daten',
        'Present data': 'Aktuelle Daten',
        'Required data': 'Erforderliche Daten',
        'Alternatively, please contact us at': 'Alternativ können Sie uns unter kontaktieren',
    },
    DealerCommunity: {
        'Sales & general information': 'Vertrieb & generelle Information',
        'Marketing & products': 'Marketing & Produkte',
        'Technical library': 'Technische Bibliothek',
        'News': 'Neuigkeiten',
        'Kalmar contacts': 'Kalmar Kontakte',
    },
    DocumentationTab: {
        'Manuals': 'Bedienungsanleitungen',
        'Manual': 'Bedienungsanleitungen',
        'Open': 'Offen',
        'Select language': 'Sprache auswählen',
        'See more manuals in other languages': 'Weitere handbücher in anderen sprachen anzeigen',
        'Search manuals with serial number': 'Handbücher mit Seriennummer suchen',
    },
    EmptyWidgets: {
        'Buy genuine parts': 'Kaufen Sie Originalteile',
        'By registering your equipment you can see manuals, contracts and more.': 'Durch die Registrierung Ihrer Maschinen erhalten Sie Zugriff auf Handbücher, Verträge und vieles mehr.',
        'Create a case': 'Anfrage stellen',
        'Do you have an inquiry?': 'Haben Sie Fragen oder ein Anliegen?',
        'Description (serial numbers of all the equipment you want to register)': 'Beschreibung (Seriennummern aller Geräte, die Sie registrieren möchten)',
        'Kalmar Services': 'Kalmar Services',
        'Performance management tool for cargo handling operations': 'Performance-Management-Tool für den Frachtumschlag.',
        'Phone number': 'Telefonnummer',
        'Registration request received': 'Registrierungsanfrage erhalten',
        'Thank you for your registration request. We will handle your request as soon as possible.': 'Vielen Dank für Ihre Registrierungsanfrage. Wir werden Ihre Anfrage so schnell wie möglich bearbeiten.',
        'User': 'Benutzer',
    },
    EquipmentAvailability: {
        'Equipment Type': 'Ausrüstungstyp',
        'Month': 'Monat',
        'Quarter': 'Quartal',
        'Year': 'Jahr',
    },
    EquipmentAvailabilityByType: {
        'Time spent': 'Aufgewendete Zeit',
    },
    Footer: {
        'General conditions': 'Allgemeine Bedingungen',
        'Kalmar in Social Media': 'Kalmar in den sozialen Medien',
        'Kalmar Digital Service Terms & Conditions': 'Allgemeine Geschäftsbedingungen für den digitalen Service von Kalmar',
        'Privacy policy': 'Datenschutz-Bestimmungen',
        'EU Data Act': 'EU Data Act (EU Datenschutzgesetz) ',
        'For data questions, please contact': 'Bei Datenfragen wenden Sie sich bitte an',
    },
    KalmarInsightWidget: {
        'equipment': 'Ausrüstung',
        'Expired license': 'Abgelaufenen Lizenz',
        'License expiring soon': 'Lizenz läuft bald ab',
        'Manage users': 'Benutzerverwaltung',
        'Number of MyKalmar INSIGHT users': 'Benutzeranzahl MyKalmar INSIGHT',
        'Valid license': 'Gültige Lizenz',
    },
    LanguageSelector: {
        'Select language': 'Sprache auswählen',
    },
    LoadingFailure: {
        'Loading cases failed': 'Laden der Fälle fehlgeschlagen',
        'Loading equipment availability failed': 'Laden der Ausrüstungsverfügbarkeit fehlgeschlagen',
        'Loading equipment failed': 'Laden der Ausrüstung fehlgeschlagen',
        'Loading failed': 'Laden fehlgeschlagen',
        'Loading maintenance schedule failed': 'Laden des Wartungsplans fehlgeschlagen',
        'Loading preventive maintenance data failed': 'Laden der Daten der vorbeugenden Wartung fehlgeschlagen',
        'Loading response time failed': 'Laden der Reaktionszeit fehlgeschlagen',
        'Loading sales orders failed': 'Laden der Kundenaufträge fehlgeschlagen',
        'Retry': 'Erneut versuchen',
    },
    MaintenanceCalendar: {
        'Equipment name': 'Ausrüstungsname',
        'Maintenance description': 'Beschreibung der Wartung',
        'No maintenance scheduled for the selected day.': 'Keine Wartung für den ausgewählten Tag geplant.',
    },
    MaintenanceReporting: {
        'Equipment Availability': 'Ausrüstungsverfügbarkeit',
        'Preventive Maintenance': 'Vorbeugende Wartung',
    },
    MaintenanceReportingWidget: {
        'Average duration from breakdown to the first service operation start': 'Average duration from breakdown to the first service operation start',
        'Average percentage the equipment was available': 'Durchschnittsprozentsatz der Ausrüstungsverfügbarkeit',
        'Planned maintenance operations that were completed on time': 'Planned maintenance operations that were completed on time',
    },
    MaintenanceScheduleWidget: {
        'No upcoming maintenances': 'Keine bevorstehenden Wartungen',
        'Upcoming maintenances': 'Bevorstehende Wartungen',
    },
    MasterHeader: {
        'Go to MyKalmar STORE or MyKalmar INSIGHT': 'Gehen Sie zu MyKalmar STORE oder MyKalmar INSIGHT',
        'Language': 'Sprache',
        'Log out': 'Abmelden',
        'MyKalmar profile': 'MyKalmar Profil',
        'You can go to MyKalmar STORE and MyKalmar INSIGHT by clicking here': 'Sie können zu MyKalmar STORE und MyKalmar INSIGHT gehen, indem Sie hier klicken',
    },
    MyCasesWidget: {
        'An unknown value': 'Ein unbekannter Wert',
        'Automation': 'Automatisierung',
        'Case': 'Fall',
        'changed from': 'geändert von',
        'Comment': 'Kommentar',
        'n/a': 'k. A.',
        'New comment': 'Neuer Kommentar',
        'No recent updates to cases': 'Keine kürzlichen Aktualisierungen bei Fällen',
        'Priority': 'Priorität',
        'Recent updates': 'Kürzliche Aktualisierungen',
        'Resolution_Date__c': 'Resolution date',
        'STORE': 'STORE',
        'to': 'zu',
        'updated': 'aktualisiert',
        'Updated at': 'Aktualisiert am',
    },
    MyEquipment: {
        'Bulletins': 'Bulletins',
        'Contracts': 'Verträge',
        'Digital subscriptions': 'Digitale Abonnements',
        'Documentation': 'Dokumentation',
        'Equipment details': 'Ausrüstungsdetails',
        'Equipment name': 'Name Equipment',
        'MyKalmar INSIGHT': 'MyKalmar INSIGHT',
        'Leasing': 'Leasing',
        'Model': 'Modell',
        'Search equipment with name, site, serial number or type': 'Ausrüstung mit Namen, Standort, Seriennummer oder Typ suchen',
        'Search with name, serial number or type': 'Mit Namen, Seriennummer oder Typ suchen',
        'Serial number': 'Seriennummer',
        'Short-term rental': 'Kurzzeitmiete',
    },
    MyEquipmentItem: {
        'Contract ends': 'Vertragsende',
        'Contract started': 'Vertragsbeginn',
        'No contracts': 'Keine Verträge',
        'Contact Kalmar for signing a contract': 'Kontaktieren Sie Kalmar zur Vertragsunterzeichnung',
        'Equipment details': 'Ausrüstungsdetails',
        'insight': 'MyKalmar INSIGHT',
        'leasing': 'Leasing',
        'Machine card': 'Maschinenkarte',
        'maintenance': 'Wartung',
        'Maintenance schedule': 'Wartungsplan',
        'Manufacturing year': 'Herstellungsjahr',
        'Model': 'Modell',
        'No data': 'Keine Daten',
        'No equipment found': 'Keine Ausrüstung gefunden',
        'Open': 'Offen',
        'Order parts': 'Teile bestellen',
        'Owner': 'Besitzer',
        'rental-short-term': 'Kurzzeitmiete',
        'Running hours': 'Betriebsstunden',
        'See Insights': 'Siehe Insights',
        'Serial number': 'Seriennummer',
        'Today': 'Heute',
        'Preventive maintenance reports': 'Präventive Wartungsberichte',
        'No preventive maintenance reports': 'Keine präventiven Wartungsberichte',
        'Preventive maintenance reports are generated after certified Kalmar service inspections. Book a service inspection with our local team to keep your equipment running reliably.':
            'Nach zertifizierten Kalmar-Wartungsinspektionen werden Berichte zur vorbeugenden Wartung erstellt. Vereinbaren Sie einen Termin für eine Wartungsinspektion mit unserem Team vor Ort, damit Ihre Maschinen zuverlässig laufen.',
        'Learn more about Kalmar maintenance': 'Erfahren Sie mehr über die Wartung von Kalmar',
        'Learn more about Kalmar Care': 'Erfahren Sie mehr über Kalmar Care',
        'Maintenance records are temporarily unavailable': 'Wartungsaufzeichnungen sind vorübergehend nicht verfügbar',
        'Service order': 'Serviceauftrag',
        'Maintenance interval': 'Wartungsintervall',
        'Date': 'Datum',
        'Faults': 'Fehler',
        'Comments': 'Kommentare',
        'View comments': 'Kommentare anzeigen',
        'Open pdf': 'PDF öffnen',
        'Chapter': 'Kapitel',
        'Checkpoint': 'Kontrollpunkt',
        'Comment': 'Kommentar',
    },
    MyEquipmentWidget: {},
    MyPartsWidget: {
        'At warehouse': 'Im Lager',
        'Customer PO': 'Kundenbestellnummer',
        'Delivered': 'Zugestellt',
        'My last parts orders': 'Meine zuletzt Teilebestellungen',
        'No orders': 'Keine Aufträge',
        'Note: this order will be delivered in multiple shipments.': 'Hinweis: Diese Bestellung wird in mehreren Lieferungen zugestellt.',
        'Order number': 'Bestellnummer',
        'Order received': 'Bestellung erhalten',
        'Processing': 'In Vorbereitung',
        'Shipment': 'Lieferung',
        'Shipped': 'Versendet',
        'Tracking': 'Verfolgung',
        'Tracking information not available at the moment': 'Verfolgungsinformationen derzeit nicht verfügbar',
        'Not available': 'Nicht verfügbar',
        'Hide tracking': 'Tracking ausblenden',
        'View tracking': 'Tracking anzeigen',
        'Please wait for tracking information...': 'Bitte warten Sie auf die Verfolgungsinformationen...',
        'Est. Delivery': 'Voraussichtliche Lieferung',
    },
    NotFound: {
        'Go to home page': 'Zur Startseite gehen',
        'Page not found': 'Seite nicht gefunden',
        'The page may have been moved or you may not have the necessary rights to access this page': 'Die Seite wurde möglicherweise verschoben oder Sie verfügen möglicherweise nicht über die notwendigen Rechte, um auf diese Seite zuzugreifen.',
    },
    PaginationTable: {
        "itemsCurrentlyShownText": "{{shownItemAmount}} von {{maxItemAmount}} werden angezeigt"
    },
    PreventiveMaintenanceCompletion: {
        'Completed': 'Abgeschlossen',
        'completed in': 'abgeschlossen in',
        'Count': 'Zählung',
        'No data for': 'Keine Daten für',
        'Not completed': 'Nicht abgeschlossen',
        'Percentage': 'Prozentsatz',
        'Planned': 'Geplant',
        'tasks': 'Aufgaben',
    },
    ResponseTime: {
        'Action started': 'Aktion gestartet',
        'avg. response time': 'Durchschn. Reaktionszeit',
        'Call started': 'Anruf gestartet',
        'in': 'in',
        'Operation': 'Betrieb',
        'Response time': 'Reaktionszeit',
    },
    ServiceRequests: {
        'All': 'Alle',
        'Breakdown Maintenance': 'Maschinenstillstand',
        'Closed': 'Abgeschlossen',
        'Corrective Maintenance': 'Reparatur',
        'Created': 'Erstellt',
        'Create new': 'Neu anlegen',
        'Customer name': 'Kundenname',
        'Enter detailed description of the maintenance request...': 'Geben Sie eine detaillierte Beschreibung der Wartungsanfrage ein …',
        'expertise, or swift troubleshooting.': 'Fachwissen oder schnelle Fehlerbehebung.',
        'Fill request form': 'Anfrageformular ausfüllen',
        'Maintenance type': 'Wartungsart',
        'Mark request as complete': 'Anfrage als abgeschlossen markieren',
        'No customer selected': 'Kein Kunde ausgewählt',
        'No service requests': 'Keine Serviceanfragen',
        'Other Maintenance': 'Sonstige Wartungsarbeiten',
        'Request received': 'Anfrage erhalten',
        'Request urgent repairs, additional maintenance': 'Dringende Reparaturen, zusätzliche Wartung',
        'Phone number': 'Telefonnummer',
        'Preferred maintenance date (Kalmar cannot guarantee maintenance on this date)': 'Bevorzugtes Wartungsdatum (Kalmar kann die Wartung an diesem Datum nicht garantieren)',
        'Preventive Maintenance': 'Vorbeugende Wartung',
        'Search request': 'Suchanfrage',
        'Equipment location': 'Standort der Ausrüstung',
        "This can't be changed": 'Dies kann nicht geändert werden',
        'Thank you for your service request. We will contact you by phone as soon as possible during business hours.': 'Vielen Dank für Ihre Serviceanfrage. Wir werden Sie so bald wie möglich während der Geschäftszeiten telefonisch kontaktieren.',
        'Your reference': 'Ihre Referenz'
    },
    SessionExpirationModal: {
        'Log in again': 'Erneut anmelden',
        'You have been logged out due to inactivity': 'Sie wurden aufgrund von Inaktivität abgemeldet',
        'Your session has expired': 'Ihre Sitzung ist abgelaufen',
    },
    SiteSelector: {
        'Customer': 'Kunde',
        'No sites with equipment': 'Keine Standorte mit Ausrüstung',
        'Select a customer': 'Einen Kunden auswählen',
        'Selected': 'Ausgewählt',
        'Show all sites': 'Alle Standorte anzeigen',
        'Showing all sites': 'Anzeige aller Standorte',
        'Recently visited': 'Zuletzt besucht',
    },
    StockEquipment: {
        'Price': 'Preis',
        'Currency': 'Währung',
        'Please select a currency for the price': 'Bitte wählen Sie eine Währung für den Preis aus',
        'Contact email': 'Kontakt-E-Mail',
        'Added': 'Hinzugefügt',
        'All': 'Alle',
        'Cancel': 'Abbrechen',
        'Close': 'Schließen',
        'Configuration number': 'Konfigurationsnummer',
        'Confirm': 'Bestätigen',
        'Create stock equipment': 'Lagergerät erstellen',
        'Datasheet': 'Datenblatt',
        'Datasheets': 'Datenblätter',
        'Delete': 'Löschen',
        'Delete this equipment. This action can’t be undone.': 'Dieses Gerät löschen. Diese Aktion kann nicht rückgängig gemacht werden.',
        'Description': 'Beschreibung',
        'Details': 'Details',
        'Documents': 'Dokumente',
        'Edit': 'Bearbeiten',
        'Engine type': 'Motortyp',
        'Equipment added successfully': 'Gerät erfolgreich hinzugefügt',
        'Equipment adding failed': 'Gerät hinzufügen fehlgeschlagen',
        'Estimated availability': 'Voraussichtliche Verfügbarkeit',
        'If you are interested in this equipment, please contact your local Kalmar sales representative or email us at': 'Wenn Sie an diesem Gerät interessiert sind, wenden Sie sich bitte an Ihren lokalen Kalmar-Vertriebsmitarbeiter oder schreiben Sie uns an',
        'Manufacturing year': 'Herstellungsjahr',
        'MAU location': 'MAU-Standort',
        'Mark as active': 'Als aktiv markieren',
        'Mark as inactive': 'Als inaktiv markieren',
        'Mark as reserved': 'Als reserviert markieren',
        'Mark as sold': 'Als verkauft markieren',
        'Cancel reservation': 'Reservierung stornieren',
        'Copy and create new': 'Kopieren und neu erstellen',
        'More options': 'Weitere Optionen',
        'ACTIVE': 'Aktiv',
        'INACTIVE': 'Inaktiv',
        'RESERVED': 'Reserviert',
        'SOLD': 'Verkauft',
        'Mark equipment as sold. This action can’t be undone.': 'Dieses Gerät als verkauft markieren. Diese Aktion kann nicht rückgängig gemacht werden.',
        'Model': 'Modell',
        'No equipment found': 'Keine Ausrüstung gefunden',
        'Picture': 'Bild',
        'Pictures': 'Bilder',
        'Ready': 'Verfügbar',
        'Region': 'Region',
        'Regions': 'Regionen',
        'Search equipment with name, serial number, description, model or site...': 'Ausrüstung nach Name, Seriennummer, Beschreibung, Modell oder Standort suchen...',
        'Search with name, serial number or description': 'Nach Name, Seriennummer oder Beschreibung suchen',
        'See all stock equipment ready to deliver': 'Alle lagerbereiten Geräte anzeigen',
        'Select equipment type': 'Gerätetyp auswählen',
        'Select region': 'Region auswählen',
        'Send': 'Senden',
        'Show on page': 'Pro Seite anzeigen',
        'Something went wrong': 'Etwas ist schiefgelaufen',
        'Specification': 'Spezifikation',
        'Specifications': 'Spezifikationen',
        'Stock equipment details': 'Details zur Lagerausrüstung',
        'Type': 'Typ',
        'Upload': 'Hochladen',
        'Picture is too large. Please upload a picture smaller than 8 MB.': 'Bild ist zu groß. Bitte laden Sie ein Bild hoch, das kleiner als 8 MB ist.',
        'Contact': 'Kontakt',
        'Stock equipment': 'Lagerausrüstung',
        'Show more': 'Mehr anzeigen',
        'Show less': 'Weniger anzeigen',
    },
    TimeUnitLinks: {
        'Show': 'Anzeigen',
    },
    Tooltips: {
        'Content': 'Content',
        'Recent reports': 'Recent reports',
    },
    TrainingRequests: {
        'All': 'Alle',
        'Closed': 'Abgeschlossen',
        'Created': 'Erstellt',
        'Create new': 'Neu anlegen',
        'Customer name': 'Kundenname',
        'Eco Driving Training': 'Eco-Driving-Schulung / Eco-Fahren Schulung',
        'Enter detailed description of the training request...': 'Geben Sie eine detaillierte Beschreibung der Schulungsanfrage ein ...',
        'Number of participants': 'Anzahl der Teilnehmer',
        'Operator Training': 'Bedienerschulung',
        'Phone number': 'Telefonnummer',
        'Preferred time frame for training (Kalmar can’t guarantee training during this time frame, the training is reserved only after Kalmar has contacted you)': 'Bevorzugter Zeitrahmen für die Schulung (Kalmar kann die Schulung in diesem Zeitrahmen nicht garantieren, die Schulung wird erst reserviert, nachdem Kalmar Sie kontaktiert hat)',
        'Product Training': 'Produktschulung',
        'Reach out to one of our training specialists today.': 'Wenden Sie sich noch heute an einen unserer Schulungsspezialisten.',
        'Receive hands-on training with heavy equipment and jobsite skills from industry professionals.': 'Erhalten Sie praktische Schulungen mit schweren Maschinen und Baustellenkenntnissen von Branchenexperten.',
        'Request received': 'Anfrage erhalten',
        'Search training': 'Schulung suchen',
        'Show requests': 'Anfragen anzeigen',
        'Technical Training': 'Anfragen anzeigen',
        'Thank you for your training request. We will contact you by phone as soon as possible during business hours.': 'Vielen Dank für Ihre Schulungsanfrage. Wir werden Sie so schnell wie möglich während der Geschäftszeiten telefonisch kontaktieren.',
        'Training type': 'Schulungsart',
    },
};
